import axios from 'axios';
import { useMutation, UseMutationOptions } from './useMutation';
import { useApp } from '../designs/paper/context/AppContext';

interface DeleteReservationParams {
  propertyId: string;
  cartSessionId: string;
  reservationDraftId: string;
}

type UseDeleteReservationOptions = UseMutationOptions<void, Error, DeleteReservationParams>;

/**
 * Hook to delete a reservation draft
 * @param options - Mutation options
 */
export function useDeleteReservation(options?: UseDeleteReservationOptions) {
  const { config } = useApp();

  return useMutation<void, Error, DeleteReservationParams>(
    async ({ cartSessionId, reservationDraftId }) => {
      await axios.delete(
        config.updateReservationUrl
          .replace(':cartId', cartSessionId)
          .replace(':draftId', reservationDraftId)
      );
    },
    options
  );
}
